/* tslint:disable */
/* eslint-disable */
/**
 * KDS API
 * Internal KDS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PlayEvent200Response,
  PlayEventRequest,
  Sync200Response,
} from '../models/index';
import {
    PlayEvent200ResponseFromJSON,
    PlayEvent200ResponseToJSON,
    PlayEventRequestFromJSON,
    PlayEventRequestToJSON,
    Sync200ResponseFromJSON,
    Sync200ResponseToJSON,
} from '../models/index';

export interface PlayEventOperationRequest {
    playEventRequest: PlayEventRequest;
}

export interface SyncRequest {
    currentEventId?: number;
}

/**
 * 
 */
export class SyncApi extends runtime.BaseAPI {

    /**
     */
    async playEventRaw(requestParameters: PlayEventOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlayEvent200Response>> {
        if (requestParameters['playEventRequest'] == null) {
            throw new runtime.RequiredError(
                'playEventRequest',
                'Required parameter "playEventRequest" was null or undefined when calling playEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/events`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PlayEventRequestToJSON(requestParameters['playEventRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlayEvent200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async playEvent(requestParameters: PlayEventOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlayEvent200Response> {
        const response = await this.playEventRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async syncRaw(requestParameters: SyncRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Sync200Response>> {
        const queryParameters: any = {};

        if (requestParameters['currentEventId'] != null) {
            queryParameters['currentEventId'] = requestParameters['currentEventId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/sync`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => Sync200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async sync(requestParameters: SyncRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Sync200Response> {
        const response = await this.syncRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
